import {
  FORM_ALERT,
  FORM_FIELD,
  RESET_FORM_DATA,
  SET_FORM_STATE
} from './mutations'

const alertDefaults = {
  type: 'info', // prop: { required: true, type: String, validator: value => ['success', 'warning', 'info', 'danger'] }
  heading: '', // prop: { required: true, type: String }
  text: null
}
const defaultFormState = {
  error: false,
  noValidate: true,
  submitting: false,
  submitted: false
}
export default {
  namespaced: true,
  state: {
    alert: {
      ...alertDefaults
    },
    formData: {
      orderId: {
        value: '',
        valid: true
      },
      queryType: {
        value: '',
        valid: true
      },
      body: {
        value: '',
        valid: true
      }
    },
    formState: {
      ...defaultFormState
    }
  },
  mutations: {
    [FORM_ALERT]: (state, alert) => {
      const stateAlertData = { ...alertDefaults, ...alert }
      state.alert = stateAlertData
    },
    [FORM_FIELD]: (state, formField) => {
      const { name, data } = formField
      const fieldData = { ...state.formData[name], ...data }
      state.formData[name] = fieldData
    },
    [RESET_FORM_DATA]: state => {
      const formFields = Object.keys(state.formData)
      formFields.forEach(field => {
        state.formData[field].value = ''
        state.formData[field].valid = true
      })
    },
    [SET_FORM_STATE]: (state, newStateProps) => {
      const newFormState = { ...defaultFormState, ...newStateProps }
      state.formState = newFormState
    }
  },
  actions: {
    /**
     * Updates state of the form alert message
     * @param {Object} context Vue context
     * @param {Object} alert see `alertDefaults` { type: ..., heading: ..., text: ... }
     */
    setFormAlert(context, alert) {
      context.commit(FORM_ALERT, alert)
    },
    /**
     * Reset Form Alert message (hide and set to type 'info')
     * @param {Object} context Vue context
     */
    resetFormAlert(context) {
      context.commit(FORM_ALERT, {})
    },
    /**
     *
     * @param {Object} context Vue context
     * @param {Object} fieldData two required props: { name, data }
     */
    setFormField(context, fieldData) {
      context.commit(FORM_FIELD, fieldData)
    },
    /**
     * Clear form data
     * @param {Object} context Vue context
     */
    resetFormData(context) {
      context.commit(RESET_FORM_DATA)
    },
    /**
     * Update form state with `newState`.
     * See `defaultFormState` props
     * @param {Object} context Vue context
     * @param {Object} newState matching `defaultFormState` { error, noValidate, submitting, submitted }
     */
    setFormState(context, newState) {
      context.commit(SET_FORM_STATE, newState)
    }
  }
}
